<template>
  <vetster-slide-over ref="areasOfInterestSlideOver">
    <template #header>
      <vetster-slide-over-common-heading
        :header="$t('search.areas-of-interest')"
        :show-close="false"
        show-back
        @back="back"
      />
    </template>

    <template #content>
      <div class="my-4 px-5">
        <vetster-areas-of-interest
          class="sm:px-2"
          :areas-of-interest="areasOfInterest"
        />

        <div class="mt-8 border border-neutral-200 rounded-md shadow-md p-5 space-y-2">
          <h3 class="text-sm font-semibold text-neutral-900">
            {{ $t('search.what-are-areas-of-interest') }}
          </h3>
          <p class="text-sm text-neutral-500">
            {{ $t('search.the-specific-categories') }}
          </p>
        </div>
      </div>
    </template>
  </vetster-slide-over>
</template>

<script>
import VetsterAreasOfInterest from '@/brand-components/VetsterAreasOfInterest';
import VetsterSlideOver from '@/brand-components/VetsterSlideOver';
import VetsterSlideOverCommonHeading from '@/brand-components/VetsterSlideOverCommonHeading';

export default {
  name: 'VetsterPartnerAreasOfInterest',

  components: {
    VetsterAreasOfInterest,
    VetsterSlideOver,
    VetsterSlideOverCommonHeading,
  },

  props: {
    areasOfInterest: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    open() {
      this.$refs.areasOfInterestSlideOver.open();
    },
    back() {
      this.$refs.areasOfInterestSlideOver.close();
    },
  },
};
</script>
